<div class="cardLayout">
    <div class="d-flex flex-row align-items-center justify-content-between">
        <h4>User authenticated?</h4>
        <lib-input-toggle [field]="field" (touchChanged)="onToggleChange($event)"></lib-input-toggle>
    </div>
    @if(!isAuthenticated()){
    <lib-alert
        style="width: fit-content"
        [alertText]="'User authentication is required'"
        [alertTheme]="'error'"
        [alertType]="'small'"
    ></lib-alert>
    }
</div>
